import styled, { css } from 'styled-components'

import { mq, sizes } from '../../../theme'
import Html from '../../atoms/Html'
import ActionButton from '../../atoms/ActionButton'
import Picture from '../../atoms/Picture'
import Icon from '../../atoms/Icon'

export const Container = styled.article`
  padding: 3rem 1.5rem;
  gap: 3rem;
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.pureWhite};
`

export const Traits = styled.ul`
  list-style: none;
  margin: 0;
  flex-wrap: wrap;
  padding: 1.5rem 1rem;
  background-color: ${({ theme }) => theme.colors.snow};
  gap: 2rem;
  border-radius: 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  @media ${mq(sizes.tablet)} {
    display: flex;
    padding: 2rem 1rem;
  }
  @media ${mq(sizes.scopingMedium)} {
    gap: 5rem;
  }
`

export const Trait = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-right: 1rem;
  & svg {
    color: ${({ theme }) => theme.colors.ruby};
    height: 2.4rem;
    width: 2.4rem;
  }
  & span {
    ${({ theme }) => theme.textStyles.textXSmallStrong};
    color: ${({ theme }) => theme.colors.arapawa};
  }
`

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  @media ${mq(sizes.tablet)} {
    gap: 5rem;
  }
`

export const Image = styled(Picture)<{ $hasBorder?: boolean }>`
  & img {
    border-radius: 1rem;
    ${({ $hasBorder }) =>
      $hasBorder &&
      css`
        border: 1px solid ${({ theme }) => theme.colors.gainsboro};
      `}
  }
  @media ${mq(sizes.tablet)} {
    width: min(calc(100% / 2), 29rem);
    flex-shrink: 0;
  }
`
export const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.5rem;
  & > ${Image} {
    display: none;
  }
  @media ${mq(sizes.tablet)} {
    flex-direction: row;
    gap: 4rem;
    & > ${Image} {
      display: block;
    }
  }
`
export const SectionWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media ${mq(sizes.tablet)} {
    & > ${Image} {
      display: none;
    }
  }
`
export const SectionTitle = styled.h2`
  ${({ theme }) => theme.textStyles.titleH3}
  color: ${({ theme }) => theme.colors.arapawa};
`

export const SectionText = styled(Html)``

export const DidYouKnow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.snow};
  border: 1px solid ${({ theme }) => theme.colors.gainsboro};
  border-radius: 2rem;
  padding: 0 2rem 2rem;
  text-align: center;
  gap: 1rem;
  & svg {
    width: 4.8rem;
    height: 4.8rem;
    color: ${({ theme }) => theme.colors.arapawa};
  }
  & > div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  @media ${mq(sizes.tablet)} {
    gap: 2rem;
    flex-direction: row;
    padding: 1.5rem;
    text-align: left;
    justify-content: flex-start;
  }
`
export const DidYouKnowTitle = styled.h3`
  ${({ theme }) => theme.textStyles.titleH5}
  margin: 0;
  color: ${({ theme }) => theme.colors.bismark};
`
export const DidYouKnowText = styled(Html)`
  ${({ theme }) => theme.textStyles.textSmall}
  color: ${({ theme }) => theme.colors.bismark};
`

export const Actions = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 2rem;
`
export const Button = styled(ActionButton)``

export const StyledIcon = styled(Icon)`
  flex-shrink: 0;
`

export const BestWith = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.snow};
  border: 1px solid ${({ theme }) => theme.colors.gainsboro};
  border-radius: 2rem;
  padding: 2rem;
  text-align: center;
  gap: 1.5rem;
  text-align: left;
  @media ${mq(sizes.tablet)} {
    flex: 0 0 auto;
    align-self: flex-start;
    width: min(calc(100% / 2), 29rem);
    flex-shrink: 0;
  }
`

export const BestWithTitle = styled.h3`
  ${({ theme }) => theme.textStyles.titleH5}
  margin: 0;
  color: ${({ theme }) => theme.colors.bismark};
`

export const BestWithEntry = styled.div`
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colors.gainsboro};
  padding-top: 1.5rem;
  gap: 1.5rem;
  & div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  & svg {
    width: 3.2rem;
    height: 3.2rem;
    background-color: ${({ theme }) => theme.colors.pureWhite};
    border-radius: 1.2rem;
    padding: 0.4rem;
    color: ${({ theme }) => theme.colors.ruby};
  }
`
export const BestWithEntryTitle = styled.h4`
  ${({ theme }) => theme.textStyles.titleH5}
  margin: 0;
  color: ${({ theme }) => theme.colors.arapawa};
`
export const BestWithEntryText = styled(Html)`
  ${({ theme }) => theme.textStyles.textSmall}
  color: ${({ theme }) => theme.colors.matterhorn};
`
